import React from 'react';

import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Facility, { FacilityCardProps } from 'Components/Card/Facility';

import { Top, Heading, Listing, ListItem } from './Facilities.styled';

export interface Props {
    id: string;
    heading: string;
    description: React.ReactNode;
    facilityCards: FacilityCardProps[];
    paddingTop?: boolean;
    showBackground?: boolean;
}

const Facilities: React.FC<Props> = props => {
    const {
        id,
        heading,
        description,
        facilityCards,
        paddingTop = false,
        showBackground = true
    } = props;

    return (
        <Section id={id} background={showBackground} paddingTop={paddingTop ? 1 : undefined}>
            <Grid>
                <Col l={7}>
                    <Top>
                        <Heading>{heading}</Heading>
                        {description}
                    </Top>
                </Col>
                <Col>
                    <Listing>
                        {facilityCards.map((card, index) => (
                            <ListItem key={index}>
                                <Facility {...card} />
                            </ListItem>
                        ))}
                    </Listing>
                </Col>
            </Grid>
        </Section>
    );
};

export default Facilities;
